"use client";

import Image from "next/image";
import Link from "next/link";

export default function HowItWorksPage() {
  return (
    <div className="overflow-hidden">
      <div>
        <div className="bg-white">
          {/* First Section */}
          <section className="bg-[#4887f5]">
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-14 lg:pb-16">
              <div className="rounded-b-semifull relative bg-[#27335d] py-10 text-white md:py-16">
                <div className="mx-auto flex flex-row items-center justify-center lg:mt-8 xl:mt-10">
                  <div className="text-start">
                    <p className="text-lg font-bold xsm:text-lg sm:text-xl md:text-[2.75rem] md:leading-none lg:text-6xl xl:text-7xl">
                      Your Arabic Journey Starts Here,
                      <span className="block">It&apos;s Easy!</span>
                    </p>
                  </div>
                </div>
                <div className="my-5 flex flex-col items-center justify-center pb-3 xsm:my-5 xsm:pb-3 sm:my-8 sm:pb-5 md:my-10 md:pb-8 lg:my-14 lg:pb-14 xl:my-16 xl:pb-16">
                  <p className="w-full text-center text-xs font-semibold text-white xsm:text-sm xsm:font-medium sm:text-lg sm:font-medium md:text-xl md:font-bold lg:text-2xl lg:font-semibold xl:text-3xl xl:font-bold">
                    From your first{" "}
                    <span>
                      <Image
                        src={"/images/svg/marhaba.svg"}
                        alt={"Marhaba"}
                        height={100}
                        width={100}
                        className="mx-auto mt-2 inline-block h-10 w-auto xsm:h-10 sm:mt-2 sm:h-12 md:mt-[0.73rem] md:h-14 lg:mt-3 lg:h-16 xl:mt-3.5 xl:h-20"
                      />
                    </span>{" "}
                    to fluency,{" "}
                    <span className="block md:inline">
                      we make learning Arabic easy{" "}
                      <span className="mt-0.5 block md:-mt-4 md:block lg:-mt-5 lg:inline xl:block">
                        and{" "}
                        <span className="md:inline lg:-mt-5 lg:block xl:inline">
                          enjoyable
                        </span>
                      </span>
                    </span>
                  </p>
                </div>
                <div className="absolute bottom-[34px] left-1/2 -translate-x-1/2 translate-y-1/2 transform xsm:bottom-[29px] sm:bottom-[37px] md:bottom-[49px] md:left-auto md:right-[2%] lg:bottom-[60px] xl:bottom-[70px] xl:right-[10%] 2xl:right-[27%]">
                  <Image
                    src="/images/svg/shukran.svg"
                    alt="Shukran"
                    width={100}
                    height={100}
                    className="z-20 h-auto w-24 object-contain xsm:w-24 sm:w-28 md:w-40 lg:w-48 xl:w-56"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Second Section */}
          <section className="bg-[#EF7E74]">
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-7 xsm:pb-7 sm:pb-9 md:pb-14 lg:pb-24">
              <div className="rounded-b-semifull bg-[#4887f5] text-white xsm:pb-9 xsm:pt-2 sm:pb-8 sm:pt-3 md:pb-20 md:pt-10 lg:pb-24 lg:pt-12 xl:pb-28 xl:pt-16">
                {/* Intro */}
                <div className="mt-10 text-center">
                  <h1 className="pb-3 text-xl font-bold tracking-tight text-[#27335D] xsm:text-xl sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                    Speak Arabic Like a Pro
                  </h1>
                  {/* Steps for MD, LG, XL... */}
                  <div className="mx-auto hidden w-fit flex-col items-center justify-center pb-10 pt-20 md:flex">
                    {/* Steps with Line */}
                    <div className="relative flex w-full items-center justify-center">
                      {/* Dashed Line */}
                      <div className="absolute left-[70px] right-[70px] top-[29px] z-10 mx-auto h-[4px] w-[80%] border-b-4 border-dashed border-[#F6C65A]"></div>
                      {/* Step 1 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-white bg-[#F6C65A] text-2xl font-bold text-[#27335d]">
                          <p>1</p>
                        </div>
                        {/* Text 1 */}
                        <div className="flex flex-col items-center text-center">
                          <h1 className="my-3 font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Sign up
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            Create your learning profile
                            <span className="block">
                              and start your first session!
                            </span>
                          </p>
                        </div>
                      </div>
                      {/* Step 2 */}
                      <div className="z-20 flex flex-col items-center md:mx-[50px] lg:mx-[100px] xl:mx-[150px]">
                        {" "}
                        {/* Reduced spacing */}
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>2</p>
                        </div>
                        {/* Text 2 */}
                        <div className="flex flex-col items-center justify-between text-center">
                          <h1 className="my-3 font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Find Your{" "}
                            <span className="text-[#F7C65A]">Arabic</span>{" "}
                            teacher
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            Every style, your journey
                            <span className="block">your choice!</span>
                          </p>
                        </div>
                      </div>
                      {/* Step 3 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>3</p>
                        </div>
                        {/* Text 3 */}
                        <div className="flex flex-col items-center text-center">
                          <h1 className="my-3 font-bold md:text-lg lg:text-xl xl:text-2xl">
                            Practice and Grow
                          </h1>
                          <p className="font-medium md:text-sm lg:text-base xl:text-lg">
                            Every word you learn
                            <span className="block">
                              brings you closer to fluency
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Steps for SM, XS, and General: Vertical Layout */}
                  <div className="mx-auto flex w-fit flex-col items-center justify-center pb-10 pt-10 md:hidden">
                    {/* Steps with Line */}
                    <div className="relative flex flex-col items-center justify-center">
                      {/* Step 1 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-white bg-[#F6C65A] text-2xl font-bold text-[#27335d]">
                          <p>1</p>
                        </div>
                        {/* Text 1 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Sign up
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            Create your learning profile
                            <span className="block">
                              and start your first session!
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Vertical Dashed Line */}
                      <div className="my-4 h-12 border-l-4 border-dashed border-[#F6C65A]"></div>

                      {/* Step 2 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>2</p>
                        </div>
                        {/* Text 2 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Find Your{" "}
                            <span className="text-[#F7C65A]">Arabic</span>{" "}
                            teacher
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            Every style, your journey
                            <span className="block">your choice!</span>
                          </p>
                        </div>
                      </div>

                      {/* Vertical Dashed Line */}
                      <div className="my-4 h-12 border-l-4 border-dashed border-[#F6C65A]"></div>

                      {/* Step 3 */}
                      <div className="z-20 flex flex-col items-center">
                        <div className="flex h-[58px] w-[60px] flex-col items-center justify-center rounded-2xl border-4 border-[#F6C65A] bg-white text-2xl font-bold text-[#D76B67]">
                          <p>3</p>
                        </div>
                        {/* Text 3 */}
                        <div className="mt-2 flex flex-col items-center text-center">
                          <h1 className="text-lg font-bold sm:text-xl">
                            Practice and Grow
                          </h1>
                          <p className="text-sm font-medium sm:text-base">
                            Every word you learn
                            <span className="block">
                              brings you closer to fluency
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Sign-up Button */}
                  <div className="mt-2 flex flex-col items-center xsm:mt-2 sm:mt-5 md:mt-12 lg:mt-14 xl:mt-16">
                    <Link href="/register" data-testid="howItWorksSignUpButton" className="inline-block transform-gpu rounded-full border-b-[5px] border-[#16294a] bg-[#1849A9] px-12 py-2.5 text-base font-bold text-white shadow-2xl transition-all duration-300 ease-out hover:bg-[#1848a9ce] active:scale-95 xsm:px-12 xsm:py-2.5 xsm:text-base sm:px-14 sm:py-3 sm:text-lg md:px-16 md:py-4 md:text-xl lg:px-20 lg:py-5 lg:text-2xl xl:px-24 xl:py-6 xl:text-3xl">
                        Sign up!
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Third Section - commented out for now */}
          {/* <section className="bg-[#EF7E74]">
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-14 lg:pb-16">
              <div className="rounded-b-semifull relative bg-[#27335d] py-10 text-white md:py-16">
                <div className="mx-auto flex w-[80%] flex-row items-center justify-start lg:mt-8 xl:mt-10">
                  <div className="text-start">
                    <h1 className="pb-3 text-xl font-bold tracking-tight text-white xsm:text-xl sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                      The Perfect Teachers, Just for You!
                    </h1>
                  </div>
                </div>
                <div id="slider" className="py-10">
                  <div className="wrapper text-start">
                    <div className="itemLeft item1">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 1"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item2">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 2"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item3">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 3"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item4">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 4"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item5">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher3.2.png"
                          alt="Story 5"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item6">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 6"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item7">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 7"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemLeft item8">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 8"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="wrapper text-start">
                    <div className="itemRight item1">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 1"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item2">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 2"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item3">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher3.2.png"
                          alt="Story 3"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item4">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 4"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item5">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher2.2.png"
                          alt="Story 5"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item6">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 6"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item7">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 7"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="itemRight item8">
                      <div className="flex items-center rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <Image
                          width={100}
                          height={100}
                          quality={100}
                          src="/images/teacher1.2.png"
                          alt="Story 8"
                          className="mr-6 h-24 w-40 rounded-md"
                        />
                        <div>
                          <p className="max-w-xs font-bold text-black">
                            Lorem ipsum dolor, sit amet consectetur adipisicing
                            elit. Hic, asperiores odit?
                          </p>
                          <p className="mt-7 text-sm text-gray-500">
                            FIRST NAME FAMILY NAME
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-6 mt-8 flex flex-row justify-center">
                  <Link href="/find-a-teacher" data-testid="howItWorksFindTeacherButton" className="inline-block transform-gpu rounded-full border-b-8 border-black bg-[#4887F5] px-4 py-3 text-lg font-bold text-[#27335d] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 sm:px-6 sm:py-4 sm:text-xl md:px-10 md:py-5 md:text-2xl">
                      Find your teacher
                  </Link>
                </div>
              </div>
            </div>
          </section> */}
          {/* Fourth Section */}
          <section className="bg-[#27335d]">
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-7 xsm:pb-7 sm:pb-9 md:pb-14 lg:pb-24">
              <div className="rounded-b-semifull relative bg-[#EF7E74] text-white xsm:pb-9 xsm:pt-2 sm:pb-8 sm:pt-3 md:pb-20 md:pt-10 lg:pb-24 lg:pt-12 xl:pb-28 xl:pt-16">
                {/* Intro */}
                <div className="text-center">
                  <h1 className="mt-8 text-xl font-bold tracking-tight text-[#27335D] xsm:mt-8 xsm:text-xl sm:mt-10 sm:text-2xl md:mt-12 md:text-5xl lg:mt-14 lg:text-6xl xl:mt-16 xl:text-7xl">
                    Your First Arabic{" "}
                    <span className="inline lg:block xl:inline">
                      Lesson{" "}
                      <span className="md:inline lg:inline xl:block">
                        On{" "}
                        <span className="md:block lg:inline xl:inline">
                          Us!
                        </span>
                      </span>
                    </span>
                  </h1>
                </div>
                {/* Content */}
                <div className="mx-auto w-[80%] space-y-5 xsm:my-8 sm:my-10 md:my-12 md:w-[40%] md:space-y-7 lg:my-14 lg:w-[38%] xl:my-16 xl:w-[30%]">
                  <p className="rounded-2xl border-2 border-[#27335D] bg-[#FCE8BD] py-3 text-center text-[1.05rem] font-bold text-[#27335D] md:rounded-3xl md:px-5 md:py-4 md:text-[1.1rem] lg:px-7 lg:py-5 lg:text-start lg:text-[1.2rem] xl:px-9 xl:py-6 xl:text-2xl">
                    Meet your teacher
                  </p>
                  <p className="rounded-2xl border-2 border-[#27335D] bg-[#F9D17B] py-3 text-center text-[1.05rem] font-bold text-[#27335D] md:rounded-3xl md:px-5 md:py-4 md:text-[1.1rem] lg:px-7 lg:py-5 lg:text-start lg:text-[1.2rem] xl:px-9 xl:py-6 xl:text-2xl">
                    Try out the fun tools
                  </p>
                  <p className="rounded-2xl border-2 border-[#27335D] bg-[#F7C65A] py-3 text-center text-[1.05rem] font-bold text-[#27335D] md:rounded-3xl md:px-5 md:py-4 md:text-[1.1rem] lg:px-7 lg:py-5 lg:text-start lg:text-[1.2rem] xl:px-9 xl:py-6 xl:text-2xl">
                    see how easy it is to learn!
                  </p>
                </div>
                {/* Get Started Button */}
                <div className="flex flex-row justify-center">
                  <Link href="/register" data-testid="howItWorksGetStartedButton" className="inline-block transform-gpu rounded-4xl border-b-8 border-[#482623] bg-[#27335D] px-11 py-3.5 text-[1.2rem] font-bold text-[#E9E9EA] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 xsm:px-11 xsm:text-base sm:px-12 sm:text-lg md:px-14 md:py-3.5 md:text-xl lg:px-16 lg:py-4 xl:px-20 xl:py-5 xl:text-2xl">
                      Get Started!
                  </Link>
                </div>
                <div className="my-5 flex flex-col items-center justify-center pb-3 xsm:my-6 xsm:pb-3 sm:my-8 sm:pb-5 md:my-10 md:pb-8 lg:my-14 lg:pb-14 xl:my-16 xl:pb-16">
                  <p className="text-center text-xs font-semibold text-[#27335D] xsm:text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
                    Your journey to fluency begins with{" "}
                    <span className="block md:inline">
                      one free click. Let’s do this!
                    </span>
                  </p>
                </div>
                <div className="absolute bottom-[27px] left-1/2 -translate-x-1/2 translate-y-1/2 transform xsm:bottom-[27px] sm:bottom-[31px] md:bottom-[46px] md:left-auto md:right-[3%] lg:bottom-[62px] lg:right-[2%] xl:bottom-[78px] xl:right-[10%] 2xl:right-[15%]">
                  <Image
                    src="/images/svg/yalla.svg"
                    alt="Yalla"
                    width={100}
                    height={100}
                    className="z-20 h-auto w-28 object-contain xsm:w-28 sm:w-32 md:w-48 lg:w-64 xl:w-80"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Fifth Section */}
          <section className="bg-[#4887f5]">
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-12 xsm:pb-12 sm:pb-14 md:pb-16 lg:pb-20">
              <div className="rounded-b-semifull relative bg-[#27335d] py-10 text-white md:py-16">
                <div className="mx-auto flex w-[80%] flex-row items-center justify-start lg:mt-8 xl:mt-10">
                  <div className="text-start">
                    <h1 className="pb-3 text-xl font-bold tracking-tight text-white xsm:text-xl sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                      Why Students Obsessed?
                    </h1>
                  </div>
                </div>
                {/* Cards */}
                <div className="mb-10 mt-12 flex flex-wrap justify-center gap-12 xsm:mb-10 xsm:mt-12 xsm:gap-12 sm:mb-12 sm:mt-14 sm:gap-14 md:mb-14 md:mt-16 md:gap-14 lg:mb-16 lg:mt-20 lg:gap-9 xl:mb-20 xl:mt-24 xl:gap-24">
                  {/* Card 1 */}
                  <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-b-8 border-[#0c0f1c] text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                    <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-4 border-[#4887f5] bg-white text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                      <div className="px-6 pb-2">
                        <Image
                          src={"/images/icon2.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto h-10 w-10 xsm:h-11 xsm:w-11 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="mb-2.5 mt-3 text-base font-bold text-[#27335D] xsm:text-lg sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Flexible Learning
                        </h1>
                        <span className="text-xs font-medium text-[#27335D] xsm:text-sm sm:text-base md:text-base lg:text-lg xl:text-base">
                          Study at your pace,
                          <span className="block">anytime, anywhere.</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-b-8 border-[#0c0f1c] text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                    <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-4 border-[#4887f5] bg-white text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                      <div className="px-6 pb-0.5">
                        <Image
                          src={"/images/icon4.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto h-10 w-10 xsm:h-11 xsm:w-11 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="my-3 text-base font-bold text-[#27335D] xsm:text-lg sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Expert Teachers
                        </h1>
                        <span className="text-xs font-medium text-[#27335D] xsm:text-sm sm:text-base md:text-base lg:text-lg xl:text-base">
                          Connect with certified Arabic instructors.
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-b-8 border-[#0c0f1c] text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                    <div className="flex h-[200px] w-[200px] flex-col items-center justify-center rounded-9xl border-4 border-[#4887f5] bg-white text-center xsm:h-[220px] xsm:w-[230px] sm:h-[240px] sm:w-[250px] lg:h-[250px] lg:w-[265px]">
                      <div className="px-6 pb-5">
                        <Image
                          src={"/images/icon3.svg"}
                          alt={"icon3"}
                          height={100}
                          width={100}
                          className="mx-auto mt-2 h-10 w-10 xsm:h-11 xsm:w-11 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="xl:textxl text-base font-bold text-[#27335D] xsm:text-lg sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Packages for Every Budget
                        </h1>
                        <span className="text-xs font-medium text-[#27335D] xsm:text-sm sm:text-base md:text-base lg:text-lg xl:text-base">
                          Hour-long 1:1 sessions with native Arabic teachers,
                          paid by credit packages.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Sixth Section */}
          <section>
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-12 xsm:pb-12 sm:pb-14 md:pb-16 lg:pb-20">
              <div className="rounded-b-semifull relative bg-[#4887f5] pb-20 pt-10 text-white xsm:pb-20 sm:pb-24 md:py-16">
                {/* Intro */}
                <div className="text-center">
                  <h1 className="mt-2 text-2xl font-bold tracking-tight text-[#27335D] xsm:mt-2 xsm:text-2xl sm:mt-4 sm:text-3xl md:mt-6 md:text-5xl lg:mt-8 lg:text-[3.6rem] xl:mt-10 xl:text-7xl">
                    Share Your Passion{" "}
                  </h1>
                  <h1 className="text-2xl font-bold tracking-tight text-[#27335D] xsm:text-2xl sm:text-3xl md:text-5xl lg:text-[3.6rem] xl:text-7xl">
                    Teach the World Arabic
                  </h1>
                  {/* Sign-up Button */}
                  <div className="my-8 flex flex-col items-center xsm:my-8 sm:my-10 md:my-12 lg:my-14 xl:my-16">
                    <Link href="/auth?role=teacher" data-testid="howItWorksTeacherSignUpButton" className="inline-block transform-gpu rounded-full border-b-8 border-black bg-[#1849A9] px-4 py-3 text-base font-bold text-white shadow-2xl transition-all duration-300 ease-out hover:bg-[#1848a9ce] active:scale-95 xsm:px-4 xsm:py-3 xsm:text-base sm:px-6 sm:py-4 sm:text-lg md:px-8 md:py-5 md:text-xl lg:px-10 lg:py-6 lg:text-2xl xl:px-12 xl:py-7 xl:text-3xl">
                        Sign up as teacher
                    </Link>
                  </div>
                </div>
                {/* Image */}
                <div className="absolute bottom-[36.5px] left-1/2 -translate-x-1/2 translate-y-1/2 transform xsm:bottom-[36.5px] sm:bottom-[42px] md:bottom-[51.5px] md:left-auto md:right-[1.5%] lg:bottom-[67.5px] lg:right-[1%] xl:bottom-[77.5px] xl:right-[5%] 2xl:right-[10%]">
                  <Image
                    src="/images/svg/clickcheck.svg"
                    alt="clickcheck"
                    width={100}
                    height={100}
                    quality={100}
                    className="z-20 h-auto w-28 object-contain xsm:w-28 sm:w-32 md:w-40 lg:w-52 xl:w-60"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
